const memoryRecallHint = {
  namespaced: true,
  state: {
    hintMedDays: 'calculating...',
    hintMigDays: 'calculating...',
    hintAffectedDays: 'calculating...',
    calculationPeriodStartTime: null,
    calculationPeriodEndTime: null
  },
  getters: {
    humanReadableStartDate: (state, getters, rootState) => {
      let options = { year: 'numeric', month: 'short', day: 'numeric', timeZone: 'UTC' }
      return new Date(state.calculationPeriodStartTime).toLocaleString(rootState.locale, options)
    },
    humanReadableEndDate: (state, getters, rootState) => {
      let options = { year: 'numeric', month: 'short', day: 'numeric', timeZone: 'UTC' }
      // -1 so that it shows up as the day before :)
      return new Date(state.calculationPeriodEndTime - 1).toLocaleString(rootState.locale, options)
    }
  },
  mutations: {
    setHintContent: (state, payload) => {
      state.hintMedDays = payload.hintMedDays
      state.hintMigDays = payload.hintMigDays
      state.hintAffectedDays = payload.hintAffectedDays
    },
    setCalculationPeriod: (state, payload) => {
      state.calculationPeriodStartTime = payload.calculationPeriodStartTime
      state.calculationPeriodEndTime = payload.calculationPeriodEndTime
    },
    clearAllHintData: (state) => {
      state.hintMedDays = 'calculating...'
      state.hintMigDays = 'calculating...'
      state.hintAffectedDays = 'calculating...'
      state.calculationPeriodStartTime = null
      state.calculationPeriodEndTime = null
    }
  },
  actions: {
    resetAllHintData ({commit}) {
      commit('clearAllHintData')
    },
    updateHintDays ({ commit }, payload) {
      let medDayList = []
      let migDayList = []
      let affectedDayList = []

      for (let med in payload.med) {
        for (let month in payload.med[med]) {
          medDayList = medDayList.concat(payload.med[med][month])
        }
      }
      for (let type in payload.mig) {
        for (let month in payload.mig[type]) {
          migDayList = migDayList.concat(payload.mig[type][month])
        }
      }

      for (let type in payload.func) {
        for (let month in payload.func[type]) {
          affectedDayList = affectedDayList.concat(payload.func[type][month])
        }
      }

      let uniqueMedDayList = new Set(medDayList)
      let uniqueMigDayList = new Set(migDayList)
      let uniqueAffectedDayList = new Set(affectedDayList)

      let hintContent = {
        hintMedDays: uniqueMedDayList.size,
        hintMigDays: uniqueMigDayList.size,
        hintAffectedDays: uniqueAffectedDayList.size
      }

      commit('setHintContent', hintContent)
    },
    updateCalculationPeriod({ commit }, payload) {
      commit('setCalculationPeriod', payload)
    }
  }
}

export default memoryRecallHint



// WEBPACK FOOTER //
// ./src/store/modules/memoryRecallHint.js